import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import './kona.css';
import showroom from "../../images/showroom/kona.png"
/**** Fotos Banner ****/
import Slider1 from "../../images/modelos/kona/banner/banner1.webp";
import Slider2 from "../../images/modelos/kona/banner/banner2.webp";
import Slider3 from "../../images/modelos/kona/banner/banner3.webp";
import Slider4 from "../../images/modelos/kona/banner/banner4.webp";
import Slider5 from "../../images/modelos/kona/banner/banner5.webp";
/****Fotos calidad de tiempo ****/
import VideoCalidad from "../../images/modelos/kona/calidad/video-calidad.mp4";
import CalidadTiempo1 from "../../images/modelos/kona/calidad/calidad1.webp";
import CalidadTiempo2 from "../../images/modelos/kona/calidad/calidad2.webp";
import Galeria1 from "../../images/modelos/kona/calidad/galeria1.webp";
import Galeria3 from "../../images/modelos/kona/calidad/galeria3.webp";
import Galeria4 from "../../images/modelos/kona/calidad/galeria4.webp";
import Galeria5 from "../../images/modelos/kona/calidad/galeria5.webp";
/****Fotos diseño ****/
import Interior1 from "../../images/modelos/kona/disenio/interior1.webp"
import Interior2 from "../../images/modelos/kona/disenio/interior2.webp"
import Interior3 from "../../images/modelos/kona/disenio/interior3.webp"
import Interior4 from "../../images/modelos/kona/disenio/interior4.webp"
import Interior5 from "../../images/modelos/kona/disenio/interior5.webp"
import Interior6 from "../../images/modelos/kona/disenio/interior6.webp"
/****Fotos rendimiento ****/
import Rendimiento1 from "../../images/modelos/kona/rendimiento/rendimiento1.webp"
import Rendimiento2 from "../../images/modelos/kona/rendimiento/rendimiento2.webp"
import Rendimiento3 from "../../images/modelos/kona/rendimiento/rendimiento3.webp"
/****Fotos seguridad ****/
import Seguridad1 from "../../images/modelos/kona/seguridad/seguridad1.webp"
import Seguridad2 from "../../images/modelos/kona/seguridad/seguridad2.webp"
import Seguridad3 from "../../images/modelos/kona/seguridad/seguridad3.webp"
import Seguridad4 from "../../images/modelos/kona/seguridad/seguridad4.webp"
import Seguridad5 from "../../images/modelos/kona/seguridad/seguridad5.webp"
import Seguridad6 from "../../images/modelos/kona/seguridad/seguridad6.webp"
import Seguridad7 from "../../images/modelos/kona/seguridad/seguridad7.webp"
import Seguridad8 from "../../images/modelos/kona/seguridad/seguridad8.webp"
/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/kona/conveniencia/conveniencia1.webp";
import Conveniencia2 from "../../images/modelos/kona/conveniencia/conveniencia2.webp";
import Conveniencia3 from "../../images/modelos/kona/conveniencia/conveniencia3.webp";
import Conveniencia4 from "../../images/modelos/kona/conveniencia/conveniencia4.webp";
import Conveniencia5 from "../../images/modelos/kona/conveniencia/conveniencia5.webp";
import Conveniencia6 from "../../images/modelos/kona/conveniencia/conveniencia6.webp";
import Conveniencia7 from "../../images/modelos/kona/conveniencia/conveniencia7.webp";
import Conveniencia8 from "../../images/modelos/kona/conveniencia/conveniencia8.webp";
import Conveniencia9 from "../../images/modelos/kona/conveniencia/conveniencia9.webp";
import LogoGarantia from "../../images/servicio/garantia/hyundai-garantia-logo.webp";
import GarantiaBateria from "../../images/servicio/garantia/garantia-bateria.webp";
import KonaCatalogo from "../../fichas/kona-hybrid-brochure.pdf";

function InfoKona() {
    const [gallerySwiper, getGallerySwiper] = useState(null);
    const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
    const gallerySwiperParams = {
        getSwiper: getGallerySwiper,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };
    const thumbnailSwiperParams = {
        getSwiper: getThumbnailSwiper,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
    };

    useEffect(() => {
        if (
            gallerySwiper !== null &&
            gallerySwiper.controller &&
            thumbnailSwiper !== null &&
            thumbnailSwiper.controller
        ) {
            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
    }, [gallerySwiper, thumbnailSwiper]);

    const onChangeMenu = (menu) => {
        switch (menu) {
            case "calidad":
                document.getElementById("tab-calidad").className = "color-hover";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-block";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;
            case "disenio":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-hover";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-block";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            case "rendimiento":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-hover";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-block";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider3;
                break;
            case "seguridad":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-hover";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-block";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider4;
                break;
            case "conveniencia":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-hover";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-block";
                document.getElementById("img-carrusel").src = Slider5;
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <link rel="preload" as="image" href={Slider1} />
            <link rel="preload" as="image" href={CalidadTiempo1} />
            <link rel="preload" as="image" href={CalidadTiempo2} />
            <link rel="preload" as="image" href={Galeria1} />
            <link rel="preload" as="image" href={Galeria3} />
            <link rel="preload" as="image" href={Galeria4} />
            <link rel="preload" as="image" href={Galeria5} />
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0">
                        <div>
                            <Image
                                src={Slider1}
                                alt="Kona Banner"
                                id="img-carrusel"
                                className="banner"
                                fluid
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">Nuevo Kona Hybrid</h1>
                        </Col>
                        <Col
                            xs={12}
                            md={6}
                            className="my-auto vehiculo-item text-md-center px-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-calidad"
                                    onClick={() => onChangeMenu("calidad")}
                                    className="color-hover"
                                >
                                    Calidad de tiempo
                                </li>
                                <li
                                    id="tab-disenio"
                                    onClick={() => onChangeMenu("disenio")}
                                    className="color-normal"
                                >
                                    Diseño
                                </li>
                                <li
                                    id="tab-rendimiento"
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="color-normal"
                                >
                                    Rendimiento
                                </li>
                                <li
                                    id="tab-seguridad"
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="color-normal"
                                >
                                    Seguridad
                                </li>
                                <li
                                    id="tab-conveniencia"
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="color-normal"
                                >
                                    Conveniencia
                                </li>
                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra">
                            <a
                                href="static/media/kona-ficha-tecnica.532f9bfd.pdf"
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Ficha</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <a
                                href={KonaCatalogo}
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Catálogo</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/cotizador/kona"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra">Cotizar</span>
                            </Link>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/test-drive/kona"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra">Test Drive</span>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/***************************************** calidad ***************************************/}
            <section id="calidad">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Nuevo Kona Hybrid</h2>
                            <h2 className="model-title">Inspirado para vibrar</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                La exclusiva apariencia del Nuevo Kona hybrid se distingue de cualquier otro SUV de su
                                clase. Su diseño actualizado y audaz le da una apariencia más aerodinámica y atlética,
                                manteniendo siempre su espíritu SUV. Este modelo te permite elegir entre una gama de
                                motores que te llevan más lejos y consumen menos combustible.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="bg-black py-2 px-2 py-md-4 px-md-0">
                            <video
                                loop
                                controls
                                style={
                                    {
                                        position: "relative",
                                        width: "100%",
                                        objectFit: "cover",
                                    }
                                }
                            >
                                <source
                                    src={VideoCalidad}
                                    type="video/mp4"
                                />
                                Your browser does not support the video tag.
                            </video>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto order-2 order-md-1">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    Más grande, atrevido y dinámico
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Con su nuevo aspecto futurista, una presencia en carretera más dinámica y mayor espacio habitable para todas tus aventuras, este audaz SUV se corona con tecnología inteligente de vanguardia.
                                </p>
                            </Col>
                            <Col md={6} className="my-auto order-1 order-md-2">
                                <Image src={CalidadTiempo1} alt="Kona Emocionante" className="img-fluid2" fluid />
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto">
                                <Image src={CalidadTiempo2} alt="Kona Innovacion" className="img-fluid2" fluid />
                            </Col>
                            <Col md={6} className="my-auto">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    Diseño unico
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    La belleza de la innovación se muestra en todas las variantes: el diseño esculpido, el frontal minimalista y las líneas aerodinámicas y fluidas resaltan el estilo futurista de Kona, que ha evolucionado hasta convertirse en un SUV de mayores dimensiones con una robusta identidad y un diseño icónico.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
                            <div>
                                <Swiper {...gallerySwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Kona Slider 1"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Kona Slider 3"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Kona Slider 4"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Kona Slider 5"
                                            className="galeria1"
                                        />
                                    </div>
                                </Swiper>
                                <Swiper {...thumbnailSwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Kona Slider 1"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Kona Slider 3"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Kona Slider 4"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Kona Slider 5"
                                            className="galeria2"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    Diseño
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** disenio ***************************************/}
            <section id="disenio" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Diseño Exterior</h2>
                            <h2 className="model-title-sub">Atrévete a ser diferente.</h2>
                            <p className="model-text mt-3 px-3 px-md-0">
                                Ofrece una combinación ganadora de versatilidad, aceleración, agilidad y conveniencia.
                                Su diseño se caracteriza por una combinación entre sofistificación y elegancia. El
                                llamativo diseño exterior destaca gracias a su sofisticación y a los nuevos paneles
                                protectores. El capó alargado fluye hasta la parrilla central, que aporta un toque más
                                potente con sus líneas limpias y definidas. La depotiva silueta se acentúa con la
                                conexión visual realizada entre las líneas laterales y la parte delantera, con un estilo
                                definido, limpio y armonioso.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <Container style={{ minHeight: '300px' }} className="cotizador pb-5">
                    <a href="https://my.matterport.com/show/?m=gXksUcj91GA" target="_blank" rel="noopener noreferrer">
                        <center>
                            <Image src={showroom} alt="Showroom Virtual Kona" fluid width={700} height={350} />
                        </center>
                    </a>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="pt-3 pt-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="model-title mb-0">Diseño Interior</h2>
                                <h2 className="model-title-sub">La innovación de la comodidad.</h2>
                                <p className="specs-text mt-3 px-3 px-md-0">
                                    Con su impresionante gama de tecnología inteligente de última generación, el Nuevo KONA Hybrid establece nuevos estándares en el segmento de los SUV subcompactos. Ahora puedes disfrutar de las últimas funciones de conectividad y comodidad inteligente, respaldadas por sistemas de seguridad y asistencia al conductor de vanguardia

                                </p>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-2 mt-4">
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior1} alt="Kona tablero" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Panel digital panorámico 12,3”
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior2} alt="Kona Pantalla" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Radio pantalla táctil de 12.3" LCD
                                </h3>
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Apple Car Play / Android Auto
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior3} alt="Kona Luces" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Cargador inalámbrico para teléfonos inteligentes
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-4">
                            <Col md={6} className="mt-3 mt-md-4">
                                <Image src={Interior4} alt="Kona tablero" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Selección de modo de conducción
                                </h3>
                            </Col>
                            <Col md={6} className="mt-3 mt-md-4">
                                <Image src={Interior5} alt="Kona Pantalla" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Aire acondicionado automático dual +
                                    ducto de ventilación posterior
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-4">
                            <Col md={12} className="mt-3 mt-md-4">
                                <Image src={Interior6} alt="Kona Interior" fluid />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("calidad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Calidad de tiempo
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    Rendimiento
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** rendimiento ***************************************/}
            <section id="rendimiento" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title-sub">Potencia y Desempeño</h2>
                            <h2 className="model-title mb-0">Conquista cualquier horizonte</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El nuevo KONA Híbrido eléctrico utiliza la energía eléctrica para ayudarte a llegar más lejos con cada litro de gasolina sin tener que cargar la batería ni cambiar tus hábitos de conducción. Este sistema de propulsión híbrido cuenta con un motor de gasolina 1.6 HEV 6DCT y un motor eléctrico que funcionan en conjunto, más un sistema de frenado regenerativo que se encarga de cargar la batería para que tú no tengas que hacerlo.
                            </p>
                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4">
                        <Col md={6} className="mt-4 mt-md-4">
                            <Image src={Rendimiento1} alt="Kona tablero" fluid />
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Motor tipo Kappa PE 1.6 HEV 6DCT / Cilindraje (CC) 1.580 / Potencia máxima combinada 141 hp / Torque máximo 265 Nm / Potencia de batería 42 kW
                            </p>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-4">
                            <Image src={Rendimiento2} alt="Kona Pantalla" fluid />
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Transmisión Automática / Shift by Wire (SBW) 6 velocidades + reversa
                            </p>
                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4 d-flex mt-md-4 justify-content-center">
                        <Col md={12} className="mt-4 mt-md-4">
                            <Image
                                src={Rendimiento3}
                                alt="Kona Banner"
                                className="w-100"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Diseño
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    Seguridad
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** seguridad ***************************************/}
            <section id="seguridad" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Seguridad y confort en movimiento</h2>
                            <h2 className="model-title mb-0">Un nuevo paradigma en seguridad</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Debido a que nada es más importante que la seguridad de sus seres queridos, KONA Hybrid
                                trae importantes funciones de seguridad para mayor tranquilidad del conductor y sus
                                pasajeros.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={6}>
                            <Image src={Seguridad1} alt="Kona Cinturones" fluid />
                            <p className="specs-text px-3 px-md-0">
                                6 Airbags (Conductor & pasajero + tórax & pelvis + cortina )
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image src={Seguridad2} alt="Kona Cinturones" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Sensores de asistencia al parquear delantero/posterior
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image src={Seguridad3} alt="Kona Carroceria" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Asistente de límite de velocidad manual (MSLA)
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image src={Seguridad4} alt="Kona Carroceria" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Asistencia para prevención de colisión en punto ciego (BCA)
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image src={Seguridad5} alt="Kona Carroceria" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Freno Multicolisión (MCB)
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image src={Seguridad6} alt="Kona Carroceria" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Freno de estacionamiento eléctrico con función Autohold
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image src={Seguridad7} alt="Kona Carroceria" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Sistema de monitoreo de presión de neumáticos (TPMS)
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image src={Seguridad8} alt="Kona Carroceria" fluid />
                            <p className="specs-text px-3 px-md-0">
                                Asistente de arranque en pendiente (HAC)
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Rendimiento
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="titulo-navegacion"
                                >
                                    Conveniencia
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** conveniencia ***************************************/}
            <section id="conveniencia" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Disfruta de funciones líderes en su clase
                            </h2>
                            <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                                Cuando se trata de confort, el  Nuevo Kona incluye una amplia gama de soluciones centradas en la funcionalidad y en la estética para que todos los pasajeros disfruten de tecnología líder en su clase.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={4}>
                                <Image
                                    src={Conveniencia1}
                                    alt="Kona mandos integrados volante"
                                    fluid
                                />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Techo corredizo con seguridad One Touch
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia2} alt="Kona botón encendido" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Luces MFR LED
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia3} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Asiento posterior plegable 60:40
                                </h3>
                            </Col>
                        </Row>
                        <Row className="text-center align-content-center">
                            <Col md={4}>
                                <Image src={Conveniencia4} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Volante de cuero con mandos integrados (Audio)
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia5} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Consola Central abierta
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image src={Conveniencia6} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Portavasos delantero
                                </h3>
                            </Col>
                            <Col md={6}>
                                <Image src={Conveniencia7} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Asiento del conductor con ajuste de altura
                                </h3>
                            </Col>
                            <Col md={6}>
                                <Image src={Conveniencia8} alt="Kona ducto ventilación" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Carga rápida y flexible.
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="mt-4 mb-4 mb-md-5">
                        <Col md={12}>
                            <Image src={Conveniencia9} alt="Kona Conveniencia" fluid />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="mx-auto">
                            <Image src={LogoGarantia} alt="Hyundai garantia" fluid />
                        </Col>
                        <Col md={4} className="mx-auto">
                            <Image src={GarantiaBateria} alt="Hyundai garantia bateria" fluid />
                        </Col>
                    </Row>
                    <br></br>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Seguridad
                                </span>
                            </Col>
                            <Col xs={6} md={6}></Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoKona;